export const IOS_af_web_dp =
  'https://itunes.apple.com/app/apple-store/id1498607143?pt=1613620&ct=interstitialdownload&mt=8';

export const Andriod_ab_web_dp = 'https://play.google.com/store/apps/details?id=com.bd.nproject';
